const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

const fallbackLabels = {
  'companions.presence.atTheTavern': 'At the Tavern',
  'companions.presence.offline': 'Offline',
  'companions.presence.away': 'Away',
  'companions.presence.awayHoursAgo': 'Away - {{count}}h ago',
  'companions.presence.yesterday': 'Yesterday',
};

const fallbackTranslator = (key, optionsOrFallback) => {
  if (typeof optionsOrFallback === 'string') return optionsOrFallback;
  if (
    optionsOrFallback &&
    typeof optionsOrFallback === 'object' &&
    'defaultValue' in optionsOrFallback
  ) {
    return String(optionsOrFallback.defaultValue).replace(
      '{{count}}',
      optionsOrFallback.count
    );
  }

  const fallback = fallbackLabels[key] || key;

  return String(fallback).replace('{{count}}', optionsOrFallback?.count);
};

export const getInitials = (name = '') =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('') || '?';

export const getPresence = (
  presence = {},
  now = new Date(),
  t = fallbackTranslator
) => {
  const lastSeenAt = presence.lastSeenAt ? new Date(presence.lastSeenAt) : null;

  if (presence.isOnline) {
    return {
      status: 'online',
      label: t('companions.presence.atTheTavern'),
      color: 'success.main',
    };
  }

  if (!lastSeenAt || Number.isNaN(lastSeenAt.getTime())) {
    return {
      status: 'offline',
      label: t('companions.presence.offline'),
      color: 'text.disabled',
    };
  }

  const diff = Math.max(0, now.getTime() - lastSeenAt.getTime());

  if (diff < 90 * MINUTE) {
    return {
      status: 'away',
      label: t('companions.presence.away'),
      color: 'secondary.main',
    };
  }

  if (diff < DAY) {
    return {
      status: 'away',
      label: t('companions.presence.awayHoursAgo', {
        count: Math.round(diff / HOUR),
      }),
      color: 'secondary.main',
    };
  }

  if (diff < 2 * DAY) {
    return {
      status: 'away',
      label: t('companions.presence.yesterday'),
      color: 'secondary.main',
    };
  }

  return {
    status: 'offline',
    label: t('companions.presence.offline'),
    color: 'text.disabled',
  };
};
